export default __webpack_public_path__ + "static/media/IMAGE_9.936bf18a.png";